import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { confirmEmail } from "../services/onboarding";
import toast from "react-hot-toast";

const ConfirmEmail = () => {
  const [responseData, setResponseData] = useState(false);
  const [emailParamVal, setEmailParamVal] = useState("");

  const safeAtob = (str) => {
    try {
      return str ? atob(str) : "";
    } catch (e) {
      return str || "";
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const emailParam = urlParams.get("emailAddress");
    const tokenParam = urlParams.get("token");

    if (emailParam) {
      setEmailParamVal(emailParam);
    }

    const decodedEmail = safeAtob(emailParam);
    const decodedToken = tokenParam;

    const verifyEmail = async () => {
      if (!decodedEmail || !decodedToken) return;
      try {
        const response = await confirmEmail({
          EmailAddress: decodedEmail,
          Token: decodedToken,
        });
        if (response.success === true) {
          setResponseData(true);
        }
      } catch (error) {
        if (error.response) {
          toast.error(error.response.data.message);
        }
      }
    };
    verifyEmail();
  }, []);

  return (
    <>
      {responseData && (
        <div className="text-center py-10 px-0 bg-email-bg h-screen">
          <div className="bg-white p-[60px] rounded-md inline-block mt-20 mx-auto">
            <div className="rounded-[200px] h-[200px] w-[200px] bg-[rgba(var(--primary-rgb),0.2)] my-0 mx-auto">
              <i className="text-[100px] leading-[200px] ml-[-15px] text-primary">
                ✓
              </i>
            </div>
            <h1 className="font-black text-[40px] mb-[10px] text-primary">
              Email Verification Successful
            </h1>
            <p className="text-xl m-0 text-navy-blue">
              You can now proceed to{" "}
              <span>
                <Link to={`/sign-up?step=profile&email=${emailParamVal}`} className="text-primary font-bold underline ml-1">
                  Complete Registration
                </Link>
              </span>
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default ConfirmEmail;
